import React from 'react';
import { createStackNavigator } from '../../navigation/stack';
import { useRoute } from '../../navigation/native';

import PreferencesScreen from './PreferencesScreen';
import { Route } from '../../app/Route';

const PreferenceStack = createStackNavigator();
const PreferencesNav = () => {
  const route = useRoute<any>();
  const screenParams = route?.params ?? {};

  return (
    <PreferenceStack.Navigator
      key={screenParams?.fromMenu ? 'preferences-from-menu' : 'preferences-default'}
      mode="modal"
      screenOptions={{
        headerShown: false,
      }}>
      <PreferenceStack.Screen
        name={Route.preferenceScreen}
        component={PreferencesScreen}
        initialParams={screenParams}
      />
    </PreferenceStack.Navigator>
  );
};

export default PreferencesNav;

interface PreferenceScreenProps {
  canNavigateBack?: boolean;
  fromMenu?: boolean;
}

export type PreferencesNavParamList = {
  Preferences: PreferenceScreenProps;
};
